import { array, InferOutput } from 'valibot'
import { EntityIdSchema } from './EntityId.type'

export const EntityIdListSchema = array(EntityIdSchema)

export type EntityIdList = InferOutput<typeof EntityIdListSchema>
